import React from 'react';
import { NavBarHeight } from '../constants';
import { FlyoutMenuContainer } from './Container/FlyoutMenuContainer';
import { FlyoutMenuBackdrop } from './Backdrop/FlyoutMenuBackdrop';
import { AnimatePresence, m } from 'framer-motion';
import { useFlyoutVariants } from './config';
export const FlyoutMenu = ({ children, opened = false, onClose, contentKey, onMouseEnter, }) => {
    const variant = useFlyoutVariants({
        initial: {
            y: '-100%',
        },
        animate: {
            y: '0%',
        },
        exit: {
            y: '-100%',
        },
    });
    React.useEffect(() => {
        if (opened) {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
            window.onscroll = () => window.scrollTo(scrollLeft, scrollTop);
        }
        else {
            window.onscroll = () => { };
        }
        return () => {
            window.onscroll = () => { };
        };
    }, [opened]);
    return (React.createElement("div", { role: "presentation" },
        React.createElement(AnimatePresence, null, opened && (React.createElement(FlyoutMenuBackdrop, { onMouseMove: onClose },
            React.createElement(m.div, Object.assign({ key: "content" }, variant),
                React.createElement(FlyoutMenuContainer, { contentKey: contentKey, onClose: onClose },
                    React.createElement("div", { onMouseMoveCapture: e => {
                            e.stopPropagation();
                            e.preventDefault();
                            if (onMouseEnter) {
                                onMouseEnter();
                            }
                        }, style: { paddingTop: `calc(32px + ${NavBarHeight}px)` } }, children))))))));
};
//# sourceMappingURL=index.js.map